import { Service } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const serviceSearchSchema = z.object({
  pId: z.string().optional(),
  stage: z.string().optional(),
  tableId: z.string().optional(),
});

export const Route = createFileRoute("/service/$id")({
  component: Service,
  validateSearch: (search) => serviceSearchSchema.parse(search),
});
